import styled from '@emotion/styled';
import { themeGet } from 'styled-system';
import { Modal as RooModal } from 'roo-ui/components';
import { ModalWithZindex } from 'components/GlobalModal/GlobalModal';

export const Modal = styled(ModalWithZindex)`
  .ModalContent {
    position: relative;
    width: 100vw;
    height: 100%;
    max-height: 100%;
    border-radius: 0;
    overflow: auto;
    -webkit-overflow-scrolling: touch;

    ${themeGet('mediaQueries.0')} {
      width: inherit;
      height: inherit;
      max-height: inherit;
      border-radius: ${themeGet('radii.default')};
    }
  }
`;

export const ModalFooter = styled(RooModal.footer)`
  position: fixed;
  bottom: 0;
  width: 100%;
  background: white;
  box-shadow: 0px -2px 4px 0px #e6e6e6;

  ${themeGet('mediaQueries.0')} {
    position: relative;
    box-shadow: none;
  }
`;

ModalFooter.displayName = 'ModalFooter';
